import { queryKeys } from '@/lib/query-client';
import { useQuery } from '@tanstack/react-query';
import { availabilityService } from '../api/availabilityService';

/**
 * Fetch approved leave blocks for resources in date range
 */
export function useResourceAvailability(start: string, end: string, userIds?: number[]) {
  return useQuery({
    queryKey: queryKeys.planner.availability(start, end, userIds),
    queryFn: () => availabilityService.getAvailability(start, end, userIds),
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: !!start && !!end,
  });
}

/**
 * Fetch capacity utilization per user per day
 */
export function useResourceCapacity(start: string, end: string, userIds?: number[]) {
  return useQuery({
    queryKey: queryKeys.planner.capacity(start, end, userIds),
    queryFn: () => availabilityService.getCapacity(start, end, userIds),
    staleTime: 2 * 60 * 1000, // 2 minutes (more dynamic, refreshes more often)
    enabled: !!start && !!end,
  });
}

/**
 * Fetch combined resource availability (capacity + leave) per user
 * This is the most comprehensive hook - returns both capacity and leave data
 */
export function useResourceAvailabilityFull(start: string, end: string, userIds?: number[]) {
  return useQuery({
    queryKey: queryKeys.planner.resourceAvailability(start, end, userIds),
    queryFn: () => availabilityService.getResourceAvailability(start, end, userIds),
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: !!start && !!end,
  });
}
